import { memo, useEffect, useState } from 'react';
import {
  queryClient,
  useMarkNotificationAsRead,
  useNewestNotification,
  useNotifications,
} from '@oai-frontend-monorepo/api';
import { Button, IconButton, Snackbar } from '@mui/material';
import React from 'react';
import { Close } from '@mui/icons-material';
import { NotificationType } from '@oai-frontend-monorepo/types';
import getRouteForNotification from './get-route-for-notification';
import { useNavigate } from 'react-router-dom';

const NotificationSnack = () => {
  const [prevNoteId, setPrevNoteId] = useState<string | undefined>(undefined);
  const [open, setOpen] = useState(false);
  const { data: newestNotification } = useNewestNotification();

  const nav = useNavigate();

  const { refetch } = useNotifications({
    limit: 10,
    page: 1,
    unread: true,
  });

  const { mutateAsync } = useMarkNotificationAsRead();

  useEffect(() => {
    // if there is a new notification and it is different from the previous one
    if (newestNotification && newestNotification.id !== prevNoteId) {
      setPrevNoteId(newestNotification.id);

      // if the new notification is unread, open the snack
      if (!newestNotification.readAt) {
        setOpen(true);
        refetch();
      }

      if (
        newestNotification.type === NotificationType.Order ||
        newestNotification.type === NotificationType.Position ||
        newestNotification.type === NotificationType.Portfolio
      ) {
        queryClient.refetchQueries({ queryKey: ['positions'] });
      }
    }
  }, [newestNotification, prevNoteId, refetch]);

  const handleClose = () => {
    if (!newestNotification) return;

    mutateAsync(newestNotification.id).then(() => {
      refetch();
    });

    setOpen(false);
  };

  const handleView = () => {
    if (!newestNotification) return;

    mutateAsync(newestNotification.id).then(() => {
      refetch();
    });

    if (
      newestNotification.type === (NotificationType.Announcement as any) &&
      newestNotification.subtype === 'LINK'
    ) {
      window.location.href = newestNotification.subtypeId || '';
      return;
    }

    const path = getRouteForNotification(newestNotification);

    nav(path);

    setOpen(false);
  };

  if (!open) {
    return null;
  }

  const action = (
    <React.Fragment>
      <Button color="primary" size="small" onClick={handleView}>
        View
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="default"
        onClick={handleClose}
      >
        <Close fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={open}
      onClose={() => setOpen(false)}
      message={newestNotification?.message}
      action={action}
    />
  );
};

export default memo(NotificationSnack);
